module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquila/aql_gc-1320eda12308715d9d335588df8a14e6.gif";